import { IFormValidator } from '../domain/Form/Form.type';
import { ReactNode } from 'react';

export class RequiredValidator implements IFormValidator<any, any> {
	validate = (params: { value: any }): ReactNode => (!params.value ? 'Обязательно для заполнения' : undefined);
}
